import { render, staticRenderFns } from "./view_medical.vue?vue&type=template&id=15778ffe&"
import script from "./view_medical.vue?vue&type=script&lang=js&"
export * from "./view_medical.vue?vue&type=script&lang=js&"
import style0 from "./view_medical.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports